import React from 'react';
import { fieldsTyps } from 'components/Form';

const renderField = (props) => {
    const {
        meta,
        dynamicComponent,
        hide
    } = props;

    const fieldName = props?.input?.name
    const fullName = fieldName?.slice(0, fieldName.lastIndexOf('.'));

    const hideField = hide?.(fieldName, fullName)

    return (
        hideField ||
        fieldsTyps[dynamicComponent](
            {
                ...props,
                ...meta
            }
        )
    )
}


export default React.memo(renderField)
